import clsx from 'clsx';
import { RELIEF_SLOTS } from 'components/Activities/Icon/ActivityIcon';
import { Checkbox } from 'components/UI/V3/Forms/Checkbox/Checkbox';
import { Switch } from 'components/UI/V3/Forms/Switch/Switch';
import { Textarea } from 'components/UI/V3/Forms/Textarea/Textarea';
import React from 'react';
import { ReliefCategoryState } from './reliefState';
import { Stepper } from './Stepper';
import styles from './ReportActivityForm.module.scss';

interface ReliefSectionProps {
    title: string;
    noteLabel: string;
    value: ReliefCategoryState;
    /* eslint-disable-next-line no-unused-vars */
    onChange: (value: ReliefCategoryState) => void;
}

const ReliefSectionComponent: React.FC<ReliefSectionProps> = ({ title, noteLabel, value, onChange }) => (
    <div className={clsx(styles.reliefSection, { [styles.reliefSectionCollapsed]: !value.enabled })}>
        <div className={styles.reliefHeader}>
            <label className={styles.reliefSwitch}>
                <Switch
                    checked={value.enabled}
                    onChange={enabled => onChange({ ...value, enabled })}
                />
                <span className={styles.reliefTitle}>{title}</span>
            </label>
            {value.enabled && <span className={styles.reliefHint}>How Many Times?</span>}
        </div>

        {value.enabled && (
            <>
                {RELIEF_SLOTS.map(slot => {
                    const slotState = value[slot.key];

                    return (
                        <div
                            key={slot.key}
                            className={styles.reliefSlot}
                        >
                            <Checkbox
                                label={slot.label}
                                className={styles.reliefSlotCheckbox}
                                checked={slotState.selected}
                                onChange={selected => onChange({ ...value, [slot.key]: { ...slotState, selected } })}
                            />
                            <Stepper
                                value={slotState.count}
                                disabled={!slotState.selected}
                                onChange={count => onChange({ ...value, [slot.key]: { ...slotState, count } })}
                            />
                        </div>
                    );
                })}

                <Textarea
                    value={value.note}
                    maxLength={500}
                    label={noteLabel}
                    placeholder="Notes here..."
                    onChange={e => onChange({ ...value, note: e.target.value })}
                />
            </>
        )}
    </div>
);

export const ReliefSection = React.memo(ReliefSectionComponent);
